import React from 'react';
import { useFormContext } from 'react-hook-form';
import useFormError from '../../hooks/useFormError';
const withFormErrors = (Component) => React.forwardRef((props, ref) => {
    const { formState: { errors } } = useFormContext();
    const [errorId, errorMessage] = useFormError(errors, props.name);
    const formErrorProps = { errorId, errorMessage };
    return React.createElement(Component, { ...formErrorProps, ...props, ref: ref });
});
export default withFormErrors;
//# sourceMappingURL=index.js.map